// What the assistant's cards say about this module, in the four languages:
// `production.assistant.phase.*`. The backend sends the key and the English
// text (section 16, backend/assistant.js); the card says it in the reader's
// language. Kept apart from index.js because it is a contract with that file: a
// key changed here is changed there.

export default {
  es: {
    phase: {
      summary: {
        plain: 'Marcar «{phase}» como hecha en {order}',
        minutes: 'Marcar «{phase}» como hecha en {order} ({minutes} min)',
      },
      action: 'Marcar una fase del taller',
      field: { order: 'Orden', phase: 'Fase', minutes: 'Minutos' },
      value: { noMinutes: 'Sin apuntar' },
      where: 'Orden de fabricación',
      after: {
        starts: 'La orden se pondrá en marcha',
        last: 'Es la última fase: la orden queda lista para completar',
        progress: '{done} de {total} fases hechas',
      },
      note: {
        alreadyDone: 'Esta fase ya está marcada',
        unknownPhase: 'Esta orden no tiene esa fase: revísala en la orden',
      },
      outcome: '«{phase}» hecha en {code} · {progress} %',
    },
  },
  ca: {
    phase: {
      summary: {
        plain: 'Marcar «{phase}» com a feta a {order}',
        minutes: 'Marcar «{phase}» com a feta a {order} ({minutes} min)',
      },
      action: 'Marcar una fase del taller',
      field: { order: 'Ordre', phase: 'Fase', minutes: 'Minuts' },
      value: { noMinutes: 'Sense apuntar' },
      where: 'Ordre de fabricació',
      after: {
        starts: 'L’ordre es posarà en marxa',
        last: 'És l’última fase: l’ordre queda llesta per completar',
        progress: '{done} de {total} fases fetes',
      },
      note: {
        alreadyDone: 'Aquesta fase ja està marcada',
        unknownPhase: 'Aquesta ordre no té aquesta fase: revisa-la a l’ordre',
      },
      outcome: '«{phase}» feta a {code} · {progress} %',
    },
  },
  en: {
    phase: {
      summary: {
        plain: 'Mark “{phase}” as done on {order}',
        minutes: 'Mark “{phase}” as done on {order} ({minutes} min)',
      },
      action: 'Tick a shop phase',
      field: { order: 'Order', phase: 'Phase', minutes: 'Minutes' },
      value: { noMinutes: 'Not logged' },
      where: 'Manufacturing order',
      after: {
        starts: 'The order will start',
        last: 'The last phase: the order is ready to be completed',
        progress: '{done} of {total} phases done',
      },
      note: {
        alreadyDone: 'This phase is already ticked',
        unknownPhase: 'This order has no such phase: check it on the order',
      },
      outcome: '“{phase}” done on {code} · {progress} %',
    },
  },
  fr: {
    phase: {
      summary: {
        plain: 'Marquer « {phase} » comme faite sur {order}',
        minutes: 'Marquer « {phase} » comme faite sur {order} ({minutes} min)',
      },
      action: 'Valider une phase d’atelier',
      field: { order: 'Ordre', phase: 'Phase', minutes: 'Minutes' },
      value: { noMinutes: 'Non saisi' },
      where: 'Ordre de fabrication',
      after: {
        starts: 'L’ordre va démarrer',
        last: 'Dernière phase : l’ordre est prêt à être terminé',
        progress: '{done} phases faites sur {total}',
      },
      note: {
        alreadyDone: 'Cette phase est déjà validée',
        unknownPhase: 'Cet ordre n’a pas cette phase : vérifiez-la sur l’ordre',
      },
      outcome: '« {phase} » faite sur {code} · {progress} %',
    },
  },
}
